import axios from '@/utils/request'

export default {
	states: ['newly', 'agreed', 'rejected',],

	// 2021-09-22
	search(params) {
		return axios.get('/weddingDressHall/damage', params)
	},
	// 2021-09-22
	inventoryDamage(params) {
		return axios.post('/weddingDressHall/damage/inventory-damage', params)
	},
	// 2021-09-22
	update(id, params) {
		return axios.put('/weddingDressHall/damage/' + id, params)
	},
	// 2021-09-22
	delete(id) {
		return axios.delete('/weddingDressHall/damage/' + id)
	},
	//  2021-09-22
	agree(id) {
		return axios.put('/weddingDressHall/damage/' + id + '/agree')
	},
	// 2021-09-22
	reject(id, params) {
		return axios.put('/weddingDressHall/damage/' + id + '/reject', params)
	},
	//  2021-09-22
	pendingAgreeCount(params) {
		return axios.get('/weddingDressHall/damage/pending-agree-count', params)
	}
}
